import { HttpTypes } from '@/types';
import { AdminCustomPageCreateResponse } from '@/types/http/custom-pages/admin/response';
import { AdminCustomPageUpdateResponse } from '@/types/http/custom-pages/admin/response';
import { AdminCustomPageDeleteResponse } from '@/types/http/custom-pages/admin/response';
import { BaseCustomPage } from '@/types/http/custom-pages/common';
import { AxiosInstance } from 'axios';

class CustomPages {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseCustomPage[]>> {
    const result = await this.client.get('/sites/pages/list', {
      params: queryParams,
    });
    return result.data;
  }

  async create(
    data: HttpTypes.AdminCustomPage
  ): Promise<HttpTypes.IResponse<AdminCustomPageCreateResponse>> {
    const result = await this.client.post('/sites/pages/create', data);
    return result.data;
  }

  async detail(id: string): Promise<HttpTypes.IResponse<BaseCustomPage>> {
    const result = await this.client.get(`/sites/pages/${id}`);
    return result.data;
  }

  async update(
    data: HttpTypes.AdminCustomPage
  ): Promise<HttpTypes.IResponse<AdminCustomPageUpdateResponse>> {
    const result = await this.client.put(`/sites/pages/update/${data.id}`, data);
    return result.data;
  }

  async delete(ids: string[]): Promise<HttpTypes.IResponse<AdminCustomPageDeleteResponse>> {
    const result = await this.client.delete(`/sites/pages/delete`, {
      data: { ids },
    });
    return result.data;
  }
  async duplicate(
    title: string
  ): Promise<HttpTypes.IResponse<{ id: string; title: string }> | string> {
    const result = await this.client.get(`/sites/pages/check-duplicate`, {
      params: {
        title,
      },
    });
    return result.data;
  }
}

export default CustomPages;
